{
  "instances": {
    "caches": {
      "label": "快取",
      "cache_manager": "快取管理",
      "loading": "正在載入快取...",
      "name": "名稱",
      "no_caches_found": "找不到快取。"
    }
  }
}
